"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var FREEZE_CLASS = 'modal-open';

/**
 * Убирает скрол у заднего фона (полезно для реализации модальны окон)
 * Добавляет класс modal-open к body
 *
 * @param defaultValue - начальное значение для заморозки
 */
var useFreezeBody = function useFreezeBody() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useState = (0, _react.useState)(defaultValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isFreeze = _useState2[0],
    setIsFreeze = _useState2[1];
  (0, _react.useEffect)(function () {
    if (isFreeze) {
      document.body.classList.add(FREEZE_CLASS);
      document.documentElement.classList.add(FREEZE_CLASS);
    } else {
      document.body.classList.remove(FREEZE_CLASS);
      document.documentElement.classList.remove(FREEZE_CLASS);
    }
    return function () {
      document.body.classList.remove(FREEZE_CLASS);
      document.documentElement.classList.remove(FREEZE_CLASS);
    };
  }, [isFreeze]);
  return {
    isFreeze: isFreeze,
    setIsFreeze: setIsFreeze
  };
};
var _default = exports["default"] = useFreezeBody;